const capitalizeWords = (text = "") => {
  return text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

export default capitalizeWords;
